


<template>
  <div v-show="visible" class="dialog">
    <Modal v-show="visible"></Modal>
    <div class="main">
      <div class="title">安全升级说明</div>
      <div class="doc">
        {{content}}
      </div>
      <div class="bottom">
        <div class="left" @click="onCancle" v-if="type">{{type === 1 ? '暂不绑卡' :'暂不充值'}}</div>
        <div class="right" @click="goUp"> 前往升级</div>
      </div>
    </div>
  </div>
</template>



<script>
import Modal from "./Modal.vue";
import { Tools } from "@lib/ggj-utils";
import qs from 'qs'

export default {
  components: {
    Modal,
  },
  props:{
       visible: {
        type: Boolean
       },
       type: {
         type: Number
       },
  },
  data() {
		let qsObj = qs.parse(location.search.slice(1))

    return {	
      content:
        "本平台近期进行网络安全升级以及主体信息更新，为确保您的正常使用，现需要您对自己的实名信息、绑定的银行卡信息以及平台协议进行确认以完成升级。",
      isApp: Tools.isApp,
      qsObj,
      fromPage: '',
    };
  },
  mounted() {
		this.fromPage = this.qsObj.fromPage
  },
  methods: {
    onCancle() {
      this.$emit('cancle')
    },
    goUp() {
      this.$goAnalyticUrl({
        type: this.isApp ? "newwebview" : "location",
        url: `${location.origin}/shero-center/pages/safeUp/index.html?fromPage=${this.fromPage}`,
        spm: "noClickExporse",
      });
    },
  },
  //   watch: {
  //     value(v) {
  // 			this.visible = v;
  // 			if (v) {
  // 				this.countDown()
  // 			}
  //     }
  //   }
};
</script>


<style lang="less" scoped>
.main {
  position: absolute;
  left: 52px;
  top: 220px;
  width: 270px;
  height: 231px;
  z-index: 9999;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  text-align: center;

  .title {
    margin-top: 24px;
    font-size: 18px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
  }
  .doc {
    margin: 12px 20px 20px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 21px;
  }
  .bottom {
    display: flex;
    height: 48px;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px #e0e0e0, inset 1px 0px 0px 0px #e0e0e0;

    .left {
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      flex: 1;
    }
    .right {
      height: 48px;
      line-height: 48px;
      flex: 1;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      box-shadow: inset 1px 0px 0px 0px #e0e0e0;
    }
  }
}
</style>
